<template>
	<el-container class="friend-page">
		<el-aside width="260px" class="friend-list-box">
			<div class="friend-list-header">
				<el-input 
					class="search-text" 
					placeholder="搜索好友(用户名/昵称)" 
					v-model="searchText"
					clearable
					@input="debounceSearch"
				>
					<i class="el-icon-search el-input__icon" slot="prefix"></i>
				</el-input>
				<el-button 
					plain 
					class="add-btn" 
					icon="el-icon-plus" 
					title="添加好友"
					@click="onShowAddFriend"
				>
				</el-button>
				<add-friend 
					:dialogVisible="showAddFriend" 
					@close="onCloseAddFriend"
				></add-friend>
			</div>
			<!-- <el-scrollbar class="friend-list-items" ref="friendList">
				<div v-for="(friend,index) in friendList" :key="index">
					<friend-item v-show="friend.nickName.startsWith(searchText)" :index="index"
						:active="friend === $store.state.friendStore.activeFriend" @chat="onSendMessage(friend)"
						@delete="onDelItem(friend,index)" @click.native="onActiveItem(friend,index)">
					</friend-item>
				</div>
			</el-scrollbar> -->
			<div 
				ref="friendList" 
				class="friend-list-items"
				@scroll="handleScroll"
			>
				<div 
					v-for="(friend, index) in validFilteredFriends" 
					:key="friend.id || index"
					:class="{ 'friend-item-wrapper': true }"
				>
					<friend-item 
						:index="index"
						:active="friend === activeFriend" 
						@chat="onSendMessage(friend)"
						@delete="onDelItem(friend, index)" 
						@click.native="onActiveItem(friend, index)"
					>
					</friend-item>
				</div>
				<div 
					v-if="loading" 
					class="loading-more"
					v-loading="loading"
				>
					<span>加载中...</span>
				</div>
				<div 
					v-else-if="hasMoreData && validFilteredFriends.length > 0"
					class="load-more-trigger"
					@click="loadMoreData"
				>
					点击加载更多
				</div>
				<div 
					v-else-if="validFilteredFriends.length === 0 && !loading"
					class="no-data"
				>
					暂无好友数据
				</div>
			</div>
		</el-aside>
		<el-container class="friend-box">
			<div class="friend-header" v-show="userInfo.id">
				{{userInfo.nickName}}
			</div>
			<div v-show="userInfo.id">
				<div class="friend-detail">
					<head-image :size="200" :name="userInfo.nickName" :url="userInfo.headImage"
						@click.native="showFullImage()"></head-image>
					<div>
						<div class="info-item">
							<el-descriptions title="好友信息" class="description" :column="1">
								<el-descriptions-item label="用户名">{{ userInfo.userName }}
								</el-descriptions-item>
								<el-descriptions-item label="昵称">{{ userInfo.nickName }}
								</el-descriptions-item>
								<el-descriptions-item label="性别">{{ userInfo.sex==0?"男":"女" }}</el-descriptions-item>
								<el-descriptions-item label="签名">{{ userInfo.signature }}</el-descriptions-item>
							</el-descriptions>

						</div>
						<div class="frient-btn-group">
							<el-button v-show="isFriend" icon="el-icon-position" type="primary"
								@click="onSendMessage(userInfo)">发消息</el-button>
							<el-button v-show="!isFriend" icon="el-icon-plus" type="primary"
								@click="onAddFriend(userInfo)">加为好友</el-button>
							<!-- <el-button v-show="isFriend" icon="el-icon-delete" type="danger"
								@click="onDelItem(userInfo,activeIdx)">删除好友</el-button> -->
						</div>
					</div>
				</div>
				<el-divider content-position="center"></el-divider>

			</div>
		</el-container>
	</el-container>
</template>

<script>
	import FriendItem from "../components/friend/FriendItem.vue";
	import AddFriend from "../components/friend/AddFriend.vue";
	import HeadImage from "../components/common/HeadImage.vue";

	export default {
		name: "friend",
		components: {
			FriendItem,
			AddFriend,
			HeadImage

		},
		data() {
			return {
				// 搜索相关
				searchText: "",
				searchTimer: null,
				
				// 对话框控制
				showAddFriend: false,
				
				// 当前选中状态
				activeIdx: -1,
				userInfo: {},
				
				// 分页数据
				allFriends: [], // 所有好友数据
				filteredFriends: [], // 搜索过滤后的数据
				displayFriends: [], // 当前显示的数据
				page: 1,
				pageSize: 50,
				isLoading: false,
				hasMore: true,
				
				// 滚动相关
				scrollTimer: null,
				isScrollLoading: false
			}
		},
		mounted() {
			this.initFriendList();
		},
		beforeDestroy() {
			// 清理定时器
			if (this.searchTimer) {
				clearTimeout(this.searchTimer);
			}
			if (this.scrollTimer) {
				clearTimeout(this.scrollTimer);
			}
		},
		methods: {
			/**
			 * 初始化好友列表
			 */
			initFriendList() {
				try {
					const friends = this.$store.state.friendStore.friends || [];
					// 确保每个好友对象都有必要的属性
					this.allFriends = friends.map(friend => ({
						...friend,
						userName: friend.userName || '',
						nickName: friend.nickName || '',
						id: friend.id || null
					}));
					this.filteredFriends = [...this.allFriends];
					this.page = 1;
					this.hasMore = true;
					this.loadPageData();
				} catch (error) {
					console.error('初始化好友列表失败:', error);
					this.$message.error('初始化好友列表失败');
				}
			},

			/**
			 * 防抖搜索
			 */
			debounceSearch() {
				if (this.searchTimer) {
					clearTimeout(this.searchTimer);
				}
				this.searchTimer = setTimeout(() => {
					this.performSearch();
				}, 300);
			},

			/**
			 * 执行搜索
			 */
			performSearch() {
				const searchText = this.searchText.trim().toLowerCase();
				
				if (!searchText) {
					this.filteredFriends = [...this.allFriends];
				} else {
					this.filteredFriends = this.allFriends.filter(friend => {
						// 安全检查属性是否存在
						const userName = friend.userName || '';
						const nickName = friend.nickName || '';
						
						return userName.toLowerCase().includes(searchText) ||
							   nickName.toLowerCase().includes(searchText);
					});
				}
				
				// 重置分页并显示第一页
				this.page = 1;
				this.displayFriends = this.filteredFriends.slice(0, this.pageSize);
				this.hasMore = this.filteredFriends.length > this.pageSize;
			},

			/**
			 * 处理滚动事件
			 */
			handleScroll(event) {
				if (this.isScrollLoading || !this.hasMore || this.isLoading) return;

				const { scrollTop, scrollHeight, clientHeight } = event.target;
				const threshold = 50; // 距离底部50px时触发

				if (scrollHeight - scrollTop - clientHeight <= threshold) {
					this.loadMoreData();
				}
			},

			/**
			 * 加载更多数据
			 */
			loadMoreData() {
				if (this.isScrollLoading || !this.hasMore || this.isLoading) return;

				this.isScrollLoading = true;
				this.page++;
				
				setTimeout(() => {
					this.loadPageData();
					this.isScrollLoading = false;
				}, 300);
			},

			/**
			 * 加载指定页数据
			 */
			loadPageData() {
				this.isLoading = true;
				
				try {
					const startIndex = 0;
					const endIndex = this.page * this.pageSize;
					const newData = this.filteredFriends.slice(startIndex, endIndex);
					
					this.displayFriends = newData;
					this.hasMore = endIndex < this.filteredFriends.length;
				} catch (error) {
					console.error('加载好友数据失败:', error);
					this.$message.error('数据加载失败: ' + (error.message || '未知错误'));
				} finally {
					this.isLoading = false;
				}
			},

			pullPrivateOfflineMessage() {
				this.$http({
					url: "/friend/page",
					params: {
						pageNum: this.page,
						pageSize: this.pageSize,
						userName: ''
					},
					method: 'get'
				}).then((data) => {
					console.log(data, 'data');
				});
			},

			onShowAddFriend() {
				this.showAddFriend = true;
			},
			onCloseAddFriend() {
				this.showAddFriend = false;
			},
			onActiveItem(friend, idx) {
				this.$store.commit("activeFriend", idx);
				this.activeIdx = idx
				this.loadUserInfo(friend, idx);
			},
			onDelItem(friend, idx) {
				this.$confirm(`确认要解除与 '${friend.nickName}'的好友关系吗?`, '确认解除?', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http({
						url: `/friend/delete/${friend.id}`,
						method: 'delete'
					}).then((data) => {
						this.$message.success("删除好友成功");
						this.$store.commit("removeFriend", idx);
						this.$store.commit("removePrivateChat", friend.id);
					}).catch(error => {
						console.error('删除好友失败:', error);
						this.$message.error("删除好友失败: " + (error.message || '网络错误'));
					})
				}).catch(() => {
					// 用户取消操作
				})
			},
			onAddFriend(user) {
				this.$http({
					url: "/friend/add",
					method: "post",
					params: {
						friendId: user.id
					}
				}).then((data) => {
					this.$message.success("添加成功，对方已成为您的好友");
					let friend = {
						id: user.id,
						nickName: user.nickName,
						headImage: user.headImage,
						online: user.online
					}
					this.$store.commit("addFriend", friend);
				}).catch(error => {
					console.error('添加好友失败:', error);
					this.$message.error("添加好友失败: " + (error.message || '网络错误'));
				})
			},
			onSendMessage(user) {
				let chat = {
					type: 'PRIVATE',
					targetId: user.id,
					showName: user.nickName,
					headImage: user.headImageThumb,
				};
				this.$store.commit("openChat", chat);
				this.$store.commit("activeChat", 0);
				this.$router.push("/home/chat");
			},
			showFullImage() {
				if (this.userInfo.headImage) {
					this.$store.commit('showFullImageBox', this.userInfo.headImage);
				}
			},
			updateFriendInfo(friend, user, index) {
				// store的数据不能直接修改，深拷贝一份store的数据
				friend = JSON.parse(JSON.stringify(friend));
				friend.headImage = user.headImageThumb;
				friend.nickName = user.nickName;
				this.$http({
					url: "/friend/update",
					method: "put",
					data: friend
				}).then(() => {
					this.$store.commit("updateFriend", friend);
					this.$store.commit("updateChatFromFriend", user);
				})
			},
			loadUserInfo(friend, index) {
				this.$http({
					url: `/user/find/${friend.id}`,
					method: 'get'
				}).then((user) => {
					this.userInfo = user;
					// 如果发现好友的头像和昵称改了，进行更新
					if (user.headImageThumb != friend.headImage ||
						user.nickName != friend.nickName) {
						this.updateFriendInfo(friend, user, index)
					}
				}).catch(error => {
					console.error('加载用户信息失败:', error);
					this.$message.error("加载用户信息失败: " + (error.message || '网络错误'));
				})
			}
		},
		computed: {
			/**
			 * 好友状态仓库
			 */
			friendStore() {
				return this.$store.state.friendStore;
			},
			
			/**
			 * 当前激活的好友
			 */
			activeFriend() {
				return this.$store.state.friendStore.activeFriend;
			},
			
			/**
			 * 是否为好友关系
			 */
			isFriend() {
				return this.friendStore.friends.some(f => f.id === this.userInfo.id);
			},
			
			/**
			 * 过滤后的好友列表
			 */
			filteredFriendList() {
				return this.displayFriends;
			},
			
			/**
			 * 有效的好友列表（过滤掉无效数据）
			 */
			validFilteredFriends() {
				return this.filteredFriendList.filter(friend => 
					friend && (friend.userName || friend.nickName)
				);
			},
			
			/**
			 * 是否还有更多数据
			 */
			hasMoreData() {
				return this.hasMore;
			},
			
			/**
			 * 加载状态
			 */
			loading() {
				return this.isLoading;
			}
		}
	}
</script>

<style lang="scss">
	.friend-page {
		.friend-list-box {
      display: flex;
      flex-direction: column;
      border: #dddddd solid 1px;
      background: white;

      .friend-list-header {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 3px 8px;
        border-bottom: 1px #ddd solid;

        .el-input__inner {
          border-radius: 10px !important;
          background-color: #F8F8F8;
          border: 1px solid #ddd;
          transition: all 0.3s ease;

          &:focus {
            border-color: #587FF0;
            background-color: white;
          }
        }

        .add-btn {
          padding: 5px !important;
          margin: 5px;
          font-size: 20px;
          color: #587FF0;
          border: #587FF0 1px solid;
          background-color: #F0F8FF;
          border-radius: 50%;
          transition: all 0.3s ease;

          &:hover {
            background-color: #587FF0;
            color: white;
            transform: scale(1.1);
          }
        }

        .search-text {
          transition: all 0.3s ease;

          &:focus {
            box-shadow: 0 0 0 2px rgba(88, 127, 240, 0.2);
          }
        }
      }

      .friend-list-items {
        flex: 1;
        margin: 0 3px;
        background: #F8F8F8;
        overflow-y: auto;
        position: relative;

        .friend-item-wrapper {
          transition: background-color 0.2s ease;
        }

        .loading-more {
          padding: 20px;
          text-align: center;
          color: #999;
        }

        .load-more-trigger {
          padding: 15px;
          text-align: center;
          color: #587FF0;
          cursor: pointer;
          background: #F0F8FF;
          border-radius: 4px;
          margin: 5px;
          transition: all 0.3s ease;

          &:hover {
            background: #E0F0FF;
            transform: translateY(-1px);
          }
        }

        .no-data {
          padding: 40px 20px;
          text-align: center;
          color: #999;
          font-size: 14px;
        }
      }

      .friend-box {
        display: flex;
        flex-direction: column;
        border: #dddddd solid 1px;

        .friend-header {
          padding: 3px;
          height: 50px;
          line-height: 50px;
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          background-color: white;
          border-bottom: 1px #ddd solid;
        }

        .friend-detail {
          display: flex;
          padding: 50px 80px 20px 80px;
          text-align: center;


          .info-item {
            margin-left: 20px;
            background-color: #ffffff;
            border-radius: 10px;
            border: 1px #ddd solid;
          }

          .description {
            padding: 20px 20px 0px 20px;
          }
        }

        .frient-btn-group {
          text-align: left !important;
          padding: 20px;
        }
      }
    }
  }
</style>